<template>
    <div class="cont-box">
        <div class="head">
            <div class="back-box" @click="goBack"><img class="icon" src="@/assets/icon_back.png" alt="back"></div>
            <div>{{this.$t('sign.title')}}</div>
        </div>
        <div class="scroll-box" @scroll="listenScroll">
            <div class="sign-head-box">
                <div class="rule-box" @click="jump">
                    <img class="icon" src="@/assets/rule.png" alt="">
                    <div>{{this.$t('sign.hdgz')}}</div>
                </div>
                <div class="sign-box" v-if="checked_in">{{this.$t('sign.yqd')}}</div>
                <div class="sign-box" v-else @click="sign">{{this.$t('sign.qd')}}</div>
            </div>
            <img class="bg" src="@/assets/background.png" alt="">
            <div class="tips">{{this.$t('sign.qdjl')}}</div>
            <div class="list-bg">
                <ul class="sign-list-box">
                    <li class="sign-list" v-for="(item,index) in listData" :key="index">
                        <div class="date">{{item.sign_time}}</div>
                        <div class="price"><span class="bold">{{item.bonus | balance}}</span> ETH</div>
                    </li>
                </ul>
            </div>
            <no-data v-show="hasData"></no-data>
        </div>
        <img id="goTop" class="go-top" @click="goTop" v-show="isGoTOP" src="@/assets/top.png" alt="">
    </div>
</template>
<script>
import noData from '@/components/noData.vue'
import VueBetterScroll from 'vue2-better-scroll'
let that;
export default {
    name: 'sign',
    data () {
        return {
            uid: '',
            token: '',
            checked_in: false,
            listData: [],
            hasData: false,
            isGoTOP: false,
            bgImg: require('@/assets/background.png'),
            curDataLength: 10,
            limit: 10,
            page: 1,
            timestamp: 0,
        }
    },
    beforeCreate() {
        that = this;
    },
    mounted(){
        this.uid = localStorage.getItem('uid');
        this.token = localStorage.getItem('token');
        this.timestamp = localStorage.getItem('timestamp') || 0;
        this.getCheckedIn();
    },
    methods: {
        getCheckedIn(){
            let params = {
                token: this.token
            }
            this.$ajax.post('/web/ethSignlog ',params).then((res) => {
                let resData = res.data.data;
                if(res.data.code == 0){
                    this.checked_in = resData.today_sign;
                    if(resData.list.length > 0){
                        this.hasData = false
                        this.listData = this.listData.concat(resData.list);
                        this.curDataLength = resData.list.length;
                    }else{
                        this.hasData = true;
                        this.curDataLength = resData.list.length;
                    }
                }else{
                    // this.$toast.center(res.data.message);
                }
            }).catch(function(err){
                console.log(err);
            })
        },
        sign(){
            let params = {
                token: this.token
            }
            this.$ajax.post('/web/ethSign',params).then((res) => {
                let resData = res.data.data;
                if(res.data.code == 0){
                    this.$toast.center(this.$t('sign.qdcg'));
                    this.getCheckedIn();
                }else{
                    this.$toast.center(this.$t('sign.yqd'));
                }
            }).catch(function(err){
                console.log(err);
            })
        },
        goBack(){
            this.$router.go(-1);
        },
        jump(){
            this.$router.push('/rule');
        },
        listenScroll(e) {  //监听滚动
            let ele = e.srcElement ? e.srcElement : e.target;
            if(ele.scrollTop > 200){
                this.isGoTOP = true
            }else{
                this.isGoTOP = false
            }
            if (ele.scrollTop + ele.offsetHeight >= ele.scrollHeight) { //监听滚动到div底部
                if(this.curDataLength > 0){
                    this.page ++;
                    this.getCheckedIn();
                }
            }
        },
        goTop(){
          $('.scroll-box').animate({scrollTop:'0px'},'slow');
        }
    },
    filters: {
        times: function(timess){
            var date = new Date((timess - that.timestamp) * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-');
            var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
            var h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
            var m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
            var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
            return Y + M + D + " " + h + m + s;
        }
    },
    components:{
        noData,
        VueBetterScroll
    }
}
</script>
<style scoped>
    .cont-box{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
    }
    .head{
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 1.2rem;
        font-size: .52rem;
        line-height: 1.2rem;
        text-align: center;
    }
    .head .icon{
        position: absolute;
        left: .3rem;
        top: 50%;
        width: .32rem;
        height: .6rem;
        transform: translateY(-50%);
    }
    .scroll-box{
        position: fixed;
        left: 0;
        top: 1.2rem;
        bottom: 0;
        z-index: 99;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .32rem;
        /* background: #0e1530;  */
        overflow: hidden;
    }
    .bg{
        position: absolute;
        top: 0;
        z-index: 0;
        width: 100%;
        height: 5rem;
        opacity: .3;
    }
    .sign-head-box{
        position: relative;
        z-index: 1;
        width: 100%;
        padding: .45rem .28rem .8rem;
        background-size: contain;
        background-repeat: no-repeat;
        box-sizing: border-box;
        text-align: center;
    }
    .sign-head-box .rule-box{
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: .1rem;
        color: #fff;
        font-size: .42rem;
        text-align: right;
    }
    .sign-head-box .rule-box .icon{
        width: .6rem;
        height: .6rem;
        margin-right: .2rem;
    }
    .sign-box{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 3.2rem;
        height: 3.2rem;
        margin: auto;
        color: #fff;
        font-size: .48rem;
        font-weight: bold;
        border-radius: 50%;
        background: rgba(49, 135, 188,.6);
        text-align: center;
    }
    .tips{
        padding: 0 .45rem .32rem;
        color: #fff;
        font-size: .42rem;
    }
    /* .list-bg{
        position: absolute;
        left: 0;
        right: 0;
        z-index: 999;
        width: auto;
        height: 7rem;
        overflow: hidden;
    } */
    .sign-list-box{
        padding: 0 .3rem;
    }
    .sign-list{
        display: flex;
        justify-content: space-between;
        align-content: center;
        margin-bottom: .24rem;
        padding: .4rem .4rem .4rem .3rem;
        border-radius: 8px;
        /* background: #1a243f; */
        background: rgba(26, 36, 63,.2);
    }
    .sign-list .date{
        color: #fff;
        font-size: .42rem;
    }
    .sign-list .price{
        color: #4bb3e8;
        font-size: .42rem;
    }
    .sign-list .price .bold{
        font-size: .48rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/sign.vue